import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-multi-lang";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { IRSSlice, IRSState, irs } from "./IRSSlice";

// API
import IrsApi from "../../services/api/irs";

// Components
import TableActionBar from "../../components/TableActionBar/TableActionBar";
import { DashboardTable } from "../../components/Table/TablePagination";
import { EllipsisLoader, WhiteboxLoader } from "../../components/Loader/Loader";
import { ClassesMenu } from "../../components/PredefinedMenus/PredefinedMenus";
import {
  SelectField,
  PageSizeSelect,
  InputField,
} from "../../components/FormElements/FormElements";
import select_vector from "../../assets/images/vectors/select.svg";

import { years } from "../../services/hoc/helpers";
import { Link } from "react-router-dom";

import { Col, Row } from "react-grid-system";
import ClientProfile_Groupe from "../Clients/SearchClient/ClientProfle/ClientProfile_Groupe";
import { isVariableDeclaration } from "typescript";
import { toast } from "react-toastify";

export default () => {
  // Translation
  const t = useTranslation();

  // Redux
  const dispatch = useDispatch();
  const state = useSelector((state: { irs: IRSState }) => state.irs);

  // Hooks
  const [keyword, setKeyword] = useState<string>("");

  const [classType, setClassType] = useState<any>();
  const [year, setYear] = useState<number>(new Date().getFullYear());
  // const [quarter, setQuarter] = useState<'q1' | 'q2' | 'q3' | 'q4'>()
  const [serachCif, setSerachCif] = useState<any>(null);
  const [ecl,setEcl]=useState<any>(null);
  const [quarter, setQuarter] = useState<string>("");
  //const [filter, setFilter] = useState<any>({ label: 'HasIRS', value: 'with' });
  const [filter, setFilter] = useState<any>({
    label: "IRS",
    value: "",
  });

  const [allchecked, setAllChecked] = React.useState<string[]>([]);
  const [selectedYear, setSelectedYear] = useState<any>();
  const [selectedQuarter, setSelectedQuarter] = useState<any>();
  const [financialStatus, setFinancialStatus] = useState<string>("");
  const [isOpenEditRate, setIsOpenEditRate] = useState<boolean>(false);
  const [showDetails, setShowDetails] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [selectedType, setSelectedType] = useState<{ [key: string]: string }>(
    {}
  );
  const currentPage = state.currentPage;
  const lastPage = state.lastPage;
  const pagesCount = state.pagesCount;

  const [pageSize, setPageSize] = useState<number>(10);

  const [filtersComplete, setFiltersComplete] = useState(false);
  const requestIdRef = useRef(0);
  // API
  const ENDPOINTS = new IrsApi();

  // Table ref
  type TableHandle = React.ElementRef<typeof DashboardTable>;
  const tableRef = useRef<TableHandle>(null);

  // Search
  const search = (value: string) => {
    tableRef.current?.reset();
    dispatch(IRSSlice.actions.reset());
    setKeyword(value);
  };

  function handleChange(e: any) {
    //setAllChecked(e.target.checked);
    if (e.target.checked) {
      setAllChecked([...allchecked, e.target.value]);
    } else {
      setAllChecked(allchecked.filter((item: any) => item !== e.target.value));
    }

    if (allchecked) {
      //alert("The all checked values are"+ allchecked.join(" , "));
    }
  }

  // Fetch Data
  const fetchData = (page: number, size: number = pageSize) => {
    const currentRequestId = ++requestIdRef.current;
    dispatch(IRSSlice.actions.setCurrentPage(page));

    dispatch(IRSSlice.actions.setIsFetching(true));

    ENDPOINTS.irs()
      .index({
        page,
        page_size: size,
        class_type_id: classType?.value,
        year: year,
        quarter: quarter,
        keyword,
        filter_type: filter.value,
        cif:serachCif,
       
      })
      .then((response: any) => {
        if (requestIdRef.current !== currentRequestId) {
          return;
        }
        //alert(response.data.data.filter_type)

        if (response.data.data.clients != null) {
          let IRSs: irs[] = response.data.data.clients.map(
            (irs: any): irs => ({
              id: irs.id,
              class_type: irs.class_type_name,
              cif: irs.cif,
              name: irs.name,
              financial_status: irs.financial_status,
              score: irs.final_score,
              grade: irs.final_grade,
              limits: irs.limits,
               onBalanceOutstanding:irs.onBalanceOutstanding,
            offBalanceOutstanding:irs.offBalanceOutstanding,
            limitOutstanding:irs.limitOutstanding,
            total_outstanding_lcy:irs.total_outstanding_lcy,
              // type_id: irs.type_id,
              account_types: irs.account_types,
              currentPage: irs.currentPage,
              lastPage: irs.lastPage,
              pagesCount: irs.pagesCount,
              selectedClients: irs.selectedClients,
            })
          );
          dispatch(
            IRSSlice.actions.setPagesCount(
              Number(response.data.data.pages_count)
            )
          );
          dispatch(
            IRSSlice.actions.addIRSs(
              IRSs.map((client) => ({
                ...client,
                isSelected: state.selectedClients.includes(client.id),
              }))
            )
          );
          // dispatch(
          //   IRSSlice.actions.setHasMore(
          //     page < Number(response.data.data.last_page)
          //   )
          // );
          // console.log(page !== Number(response.data.data.last_page));
          if (!state.isLoaded) dispatch(IRSSlice.actions.setIsLoaded(true));
          dispatch(IRSSlice.actions.setIsFetching(false));
        }
      });
  };

  const fetchFilteredData = () => {
    if (state.filtersComplete) {
      fetchData(1);
    }
  };

  useEffect(() => {
    const allFiltersSelected = classType && year && quarter && filter;
    dispatch(IRSSlice.actions.setFiltersComplete(!!allFiltersSelected));

    if (allFiltersSelected) {
      tableRef.current?.reset();
      dispatch(IRSSlice.actions.reset());
      fetchFilteredData();
    }
  }, [classType, year, quarter, filter,serachCif]);





  useEffect(() => {
  

  
      tableRef.current?.reset();
      dispatch(IRSSlice.actions.reset());
       fetchData(1);
    
  }, [serachCif]);







  interface tableDataType {
    [key: string]: { [key: string]: any };
  }
  const generateData: () => tableDataType = () => {
    let data: tableDataType = {};
    if (Array.isArray(state.IRSs)) {
      state.IRSs.forEach((irs, index) => {
        if (irs != null) {
          //alert(irs.year)

          data[irs.id] = {
            actions1:
              irs.class_type != "Retail" &&
              irs.class_type != "Local Bank" &&
              irs.class_type != "Abroad Bank" &&
              irs.class_type != "Investments" &&
              irs.class_type != "Central Bank" ? (
                <div className="SimpleCheckbox">
                  <input
                    type="checkbox"
                    value={irs.cif}
                    checked={state.selectedClients.includes(irs.cif)}
                    onChange={() =>
                      dispatch(IRSSlice.actions.toggleClientSelection(irs.cif))
                    }
                  />
                </div>
              ) : (
                ""
              ),

            class_type: irs.cif,
            year: irs.name,
            quarter: irs.class_type,
            financial_status: irs.financial_status,

            score: irs.score,

            grade: irs.grade,
            onBalanceOutstanding:irs.onBalanceOutstanding,
            offBalanceOutstanding:irs.offBalanceOutstanding,
            limitOutstanding:irs.limitOutstanding,
            total_outstanding_lcy:irs.total_outstanding_lcy,
     

            actions: (
              <div className="click">
                {irs.account_types && irs.account_types.length > 0 && (
                  <select
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setSelectedType((prev) => ({
                        ...prev,
                        [irs.id]: selectedValue,
                      }));
                      setShowDetails((prev) => ({
                        ...prev,
                        [irs.id]: true,
                      }));
                    }}
                    value={selectedType[irs.id] || ""}
                  >
                    <option disabled value="">
                      Select account type
                    </option>
                    <optgroup label="Account Type">
                      {irs.account_types.map((item: any, index: number) => (
                        <option key={index} value={item.toLowerCase()}>
                          {item}
                        </option>
                      ))}
                    </optgroup>
                  </select>
                )}
              </div>
            ),
            actyion2: (
              <div>
                {showDetails[irs.id] && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      selectedType[irs.id] === "onbalance"
                        ? `/search-client?cif=${irs.cif}` +
                          (year ? `&year=${year}` : "") +
                          (quarter ? `&quarter=${quarter}` : "")
                        : selectedType[irs.id] === "offbalance"
                        ? `/search-client?cif=${irs.cif}` +
                          (year ? `&year=${year}` : "") +
                          (quarter ? `&quarter=${quarter}` : "") +
                          "&client_type=offbalance"
                        : `/search-client?cif=${irs.cif}` +
                          (year ? `&year=${year}` : "") +
                          (quarter ? `&quarter=${quarter}` : "") +
                          "&limits=yes&client_type=offbalance"
                    }
                  >
                    <i className="icon-info" style={{ color: "#333" }} />
                  </a>
                )}
              </div>
            ),
          };
        }
      });
    }

    return data;
  };

  // First fetch
  useEffect(() => {
    if (!state.isLoaded && !state.isFetching) fetchData(1);
  }, []);

  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isFetching ? <WhiteboxLoader /> : ""}
          <form>
            
            <div className="filters">
              <div className="filter">
         
                <SelectField
                  placeholder="Filter"
                  options={[
                    { label: "All", value: "all" },
                    { label: "Has IRS", value: "with" },
                    { label: "No IRS", value: "without" },
                  ]}
                  onChange={(selected: any) => setFilter(selected)}
                  value={filter}
                  
                />
        
              </div>
              <div className="filter" key="IRSFilter">
                <ClassesMenu
                  isClearable
                  value={classType}
                  onChange={(selected: any) => setClassType(selected)}
                  placeholder="Filter by class type"
                />
              </div>
              <div className="filter">
                <SelectField
                  isClearable
                  defaultValue={year ? { label: year, value: year } : undefined}
                  onChange={(selected: { value: number }) =>
                    setYear(selected?.value)
                  }
                  placeholder={t("year")}
                  options={years}
                />
              </div>
              <div className="filter">
                <SelectField
                  isClearable
                  defaultValue={
                    quarter
                      ? { label: quarter?.toUpperCase(), value: quarter }
                      : undefined
                  }
                  onChange={(selected: { value: "q1" | "q2" | "q3" | "q4" }) =>
                    setQuarter(selected?.value)
                  }
                  placeholder={t("quarter")}
                  options={[
                    { label: "Q1", value: "q1" },
                    { label: "Q2", value: "q2" },
                    { label: "Q3", value: "q3" },
                    { label: "Q4", value: "q4" },
                  ]}
                />
              </div>
              <div className="filter">
                                 <InputField
          value={serachCif}
          type="text"
          placeholder={t('Cif')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSerachCif(e.currentTarget.value);
    
         
          }}
        />
           
   {/* <button
  type="button"
  className="button bg-gold color-white round"
  style={{ width: 200 }}
  onClick={() => {
    if (!year || !quarter) {
      toast("You need Select Year and Quarter.", {
        progressStyle: { background: "tomato" },
      });
      return;
    }

    setEcl(true);
  }}
>
  Calculate ECL
</button> */}
   
 
              </div>
              
         
            </div>
            
          </form>
        
          <TableActionBar title={t("irs")} search={search} showFilter={false} />

          {/* Client rate */}
          {/*<ClientStage isOpen={isOpenEditStage} toggle={() => setIsOpenEditStage(false)} client_id={client.id}  year={selectedYear?.value} quarter={selectedQuarter?.value} class_type={client.class_type_id}  isUpdate={isUpdate} />  */}

          {/*  <ClientStage_Groupe isOpen={isOpenEditStage} toggle={() => setIsOpenEditStage(false)} client_id={allchecked}  year={year}    quarter={quarter} class_type={1}  isUpdate={false} />*/}

          {/* Client Rate */}
          <ClientProfile_Groupe
            isOpen={isOpenEditRate}
            toggle={() => {
              setIsOpenEditRate(false);
              dispatch(IRSSlice.actions.clearSelectedClients());
            }}
            client_id={state.selectedClients.map((cif) => cif.toString())}
            year={year}
            quarter={quarter}
            class_type={classType?.value}
            financial_status={financialStatus}
            changeFinancialStatus={setFinancialStatus}
            isUpdate={false}
          />
          {state.filtersComplete && Object.keys(generateData()).length > 0 ? (
            <div className="search-client-actions">
              <Row>
                <Col md={12}>
                  <Row>
                    {/* Client_rate */}

                    <Col
                      md={6}
                      style={{
                        position: "sticky",
                        top: 11,
                        marginTop:40,
                        textAlign: "right",
                      }}
                      className="actions"
                    >
                      <button
                        className="button color-gold"
                        onClick={() => {
                          //  alert("classType is :" + classType)
                          if (classType == undefined)
                            window.alert(
                              "Please you must select input type in the filter"
                            );
                          else setIsOpenEditRate(true);
                          setSelectedYear(selectedYear);
                          setSelectedQuarter(selectedQuarter);
                        }}
                      >
                        {t("Add Same rate to Selected Clients")}
                      </button>

                      <span className="margin-10" />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ) : (
            <></>
          )}
          {(state.filtersComplete||serachCif) && Object.keys(generateData()).length > 0 ? (
            <DashboardTable
              ref={tableRef}
              header={[
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <input
                    type="checkbox"
                    checked={
                      state.IRSs.length > 0 &&
                      state.IRSs.every((client) =>
                        state.selectedClients.includes(client.cif)
                      )
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        dispatch(IRSSlice.actions.selectAllClients());
                      } else {
                        dispatch(IRSSlice.actions.unselectAllClients());
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  <label style={{ margin: 0 }}>{t("Select")}</label>
                </div>,
                t("cif"),
                t("name"),
                t("class_type"),
                t("financial_status"),
                t("score"),
                t("grade"),
               ("OnBalanceOutstanding"),
                ("OffBalanceOutstanding"),
                ("LimitOutstanding"),
                ("Total outstanding lcy"),
                "Account Types",
                "Details",
              ]}
              body={generateData()}
              selectable
              onSelect={() => {}}
              loadMore={(page: number) => fetchData(page)}
              pagesCount={pagesCount}
            />
          ) : (
            <div className="center">
              <br /> <br /> <br /> <br />
              <br /> <br />
              <br /> <br />
              <img src={select_vector} style={{ maxWidth: 500 }} />
              <p>Please select all filters</p>
            </div>
          )}
          {/* Pagination footer */}
          {state.filtersComplete && Object.keys(generateData()).length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: 70,
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  position: "relative",
                  top: "-45px",
                  marginLeft: "250px",
                }}
              >
                <PageSizeSelect
                  value={pageSize}
                  onChange={(val: number) => {
                    setPageSize(val);
                    tableRef.current?.reset();
                    fetchData(1, val);
                  }}
                  options={[
                    { label: "10", value: 10 },
                    { label: "20", value: 20 },
                    { label: "30", value: 30 },
                    { label: "50", value: 50 },
                    { label: "100", value: 100 },
                  ]}
                />
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
